
import React from 'react';
import { Form } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Company } from '@/types/company';
import { LogoUploader } from './branding/LogoUploader';
import { ColorPalette } from './branding/ColorPalette';
import { useBrandingForm } from './branding/use-branding-form';

export default function BrandingForm({ company }: { company: Company }) {
  const { form, isSubmitting, onSubmit } = useBrandingForm(company);
  
  const handleLogoChange = (logoUrl: string | null) => {
    form.setValue('logoUrl', logoUrl);
  };
  
  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Logo de la empresa */}
          <LogoUploader 
            companyId={company.id}
            initialLogo={company.theme?.logoUrl || null}
            onLogoChange={handleLogoChange}
          />
          
          {/* Paleta de colores */}
          <div className="space-y-4">
            <h3 className="text-lg font-medium">Paleta de colores</h3>
            <ColorPalette form={form} />
          </div>
        </div>
        
        <Separator />
        
        <div className="flex justify-end">
          <Button 
            type="submit" 
            className="w-full sm:w-auto"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Guardando...' : 'Guardar cambios'}
          </Button>
        </div>
      </form>
    </Form>
  );
}
